/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { capitalize } from '@veeam-vspc/shared/helpers';
import { colors as palette, useGlobalLang, useGlobalServices } from '@veeam-vspc/shared/components';

import type { VspcLang } from 'configs/languages';

import { BaseTrendChart } from '../../../BaseTrendChart';
import { ConsumedStorageService } from './services/consumed-storage.service';

export const ConsumedStorage: React.FC = () => {
    const lang = useGlobalLang<VspcLang>();
    const { transportService } = useGlobalServices();

    const params = {
        colors: [palette.B400],
        yTitle: lang.SIZE,
    };

    return (
        <BaseTrendChart
            params={params}
            service={new ConsumedStorageService(transportService, lang)}
            title={{ text: capitalize(lang.CONSUMED_STORAGE) }}
        />
    );
};
